import { ReactComponent as ToListIcon } from 'assets/imgs/airdrop/to.svg'
import { ReactComponent as PositionCloseIcon } from 'assets/svg/trade/close.svg'
import { ReactComponent as PositionEditIcon } from 'assets/svg/trade/edit.svg'
import { ReactComponent as PositionEntryIcon } from 'assets/svg/trade/entryIcon.svg'
import { ReactComponent as PositionLiqIcon } from 'assets/svg/trade/liqIcon.svg'
import styled from 'styled-components/macro'

import { ReactComponent as ShareIcon } from '../../assets/imgs/airdrop/ranking/share.svg'
import { ReactComponent as WinIcon } from '../../assets/imgs/airdrop/win.svg'
import { ReactComponent as ArrowDownIcon } from '../../assets/imgs/arrowDown.svg'
import { ReactComponent as BackIcon } from '../../assets/imgs/back.svg'
import { ReactComponent as CloseIcon } from '../../assets/imgs/close.svg'
import { ReactComponent as CloseIcon2 } from '../../assets/imgs/confirmation/close.svg'
import { ReactComponent as CopyIcon } from '../../assets/imgs/copy.svg'
import { ReactComponent as DiscordIcon } from '../../assets/imgs/discord.svg'
import { ReactComponent as DocIcon } from '../../assets/imgs/doc.svg'
import { ReactComponent as DropDownIcon } from '../../assets/imgs/down.svg'
import { ReactComponent as ExchangeIcon } from '../../assets/imgs/exchange.svg'
import { ReactComponent as ChangeIcon } from '../../assets/imgs/orderList/change.svg'
import { ReactComponent as SettingIcon } from '../../assets/imgs/setting.svg'
import { ReactComponent as SettingIcon2 } from '../../assets/imgs/setting2.svg'
import { ReactComponent as StarIcon } from '../../assets/imgs/star.svg'
import { ReactComponent as TelegramIcon } from '../../assets/imgs/telegram.svg'
import { ReactComponent as TipsDarkIcon } from '../../assets/imgs/tips_dark.svg'
import { ReactComponent as TipsLightIcon } from '../../assets/imgs/tips_light.svg'
import { ReactComponent as ToIcon } from '../../assets/imgs/to.svg'
import { ReactComponent as TwitterIcon } from '../../assets/imgs/twitter.svg'
import { ReactComponent as DelIcon } from '../../assets/svg/close.svg'
import { ReactComponent as ExternalIcon } from '../../assets/svg/external.svg'
import { ReactComponent as PriceChangeIcon } from '../../assets/svg/trade/change.svg'

export const StyledToListIcon = styled(ToListIcon)`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledExternalIcon = styled(ExternalIcon)`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledDocIcon = styled(DocIcon)`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledDiscordIcon = styled(DiscordIcon)`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledTelegramIcon = styled(TelegramIcon)`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledTwitterIcon = styled(TwitterIcon)`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledDropDown = styled(DropDownIcon)<{ selected?: boolean }>`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledArrowDown = styled(ArrowDownIcon)`
  path {
    stroke: ${({ theme }) => theme.textTabActive};
  }
`

export const StyledExchange = styled(ExchangeIcon)`
  cursor: pointer;
  path {
    stroke: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledSetting = styled(SettingIcon2)`
  path {
    fill: ${({ theme }) => theme.primaryBtn};
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.closeIconBg};
  }
`

export const StyledCloseIcon2 = styled(CloseIcon2)`
  cursor: pointer;
`

export const StyledDelIcon = styled(DelIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledVoteCloseIcon = styled(CloseIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.textTertiary};
  }
`

export const StyledCopyIcon = styled(CopyIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.iconBg};
  }
  &:hover {
    path {
      fill: ${({ theme }) => theme.iconHoverBg};
    }
  }
`

export const StyledShareIcon = styled(ShareIcon)`
  &:hover {
    path {
      fill: ${({ theme }) => theme.white};
    }
  }
`

export const StyledToIcon = styled(ToIcon)`
  path {
    stroke: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledTipsDarkIcon = styled(TipsDarkIcon)`
  cursor: pointer;
  &:hover {
    circle {
      fill: linear-gradient(270deg, rgba(9, 35, 6, 0.1) 0.76%, rgba(20, 182, 0, 0.101961) 48.6%, rgba(0, 126, 73, 0.101961) 117.5%);
    }
  }
`

export const StyledTipsLightIcon = styled(TipsLightIcon)`
  cursor: pointer;
  &:hover {
    circle {
      fill: linear-gradient(270deg, rgba(9, 35, 6, 0.1) 0.76%, rgba(20, 182, 0, 0.101961) 48.6%, rgba(0, 126, 73, 0.101961) 117.5%);
    }
  }
`

export const StyledBackIcon = styled(BackIcon)`
  cursor: pointer;
  path {
    stroke: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledChangeIcon = styled(ChangeIcon)`
  cursor: pointer;
  path {
    stroke: ${({ theme }) => theme.textSecondary};
  }
`

export const StyledStarIcon = styled(StarIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.textTertiary};
  }
`

export const StyledPriceChangeIcon = styled(PriceChangeIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.textTertiary};
  }
`

export const StyledPositionCloseIcon = styled(PositionCloseIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.textTertiary};
  }
`

export const StyledPositionEditIcon = styled(PositionEditIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.textTertiary};
  }
`

export const StyledPositionLiqIcon = styled(PositionLiqIcon)`
  cursor: pointer;
  path {
    fill: ${({ theme }) => theme.textTertiary};
  }
`

export const StyledPositionEntryIcon = styled(PositionEntryIcon)`
  cursor: pointer;
  .path1 {
    fill: ${({ theme }) => theme.backgroundInteractive};
  }
  .path2 {
    fill: ${({ theme }) => theme.textTertiary};
  }
`

export const StyledSettingIcon = styled(SettingIcon)`
  path {
    fill: ${({ theme }) => theme.textSecondary};
  }
`
export const StyledWinIcon = styled(WinIcon)`
  path {
    fill: ${({ theme }) => theme.sectionBorder};
  }
`
